import { render } from "./AddPaymentMethods.vue?vue&type=template&id=3a6aa7d9"
import script from "./AddPaymentMethods.vue?vue&type=script&lang=js"
export * from "./AddPaymentMethods.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__